import axios from "~/Utils/axios";

class FilesServices {
  fetchRemoveFile(id) {
    return axios.delete(`/files/${id}`);
  }
}

export default new FilesServices();
